<template>
    <div class="list-item" ref="listItem">
        <div class="list-item__main">
            <ur-checkbox v-if="mode == 'check'" v-model="value" class="list-item__check"/>
            <ur-radio v-else-if="mode == 'radio'" v-model="value" class="list-item__check"/>
            <!--
                $ver: v0.1.0
                <em>ur-list</em> 컴포넌트로 표현되는 리스트 목록의 내부 영역입니다.
                #The internal area of ​​the list of lists represented by the <em>ur-list</em> component.
            -->
            <slot/>
            <div v-if="expandable" class="list-item__support">
                <ur-icon v-if="isExpend" sm @click="toggleExpand">collapse_menu</ur-icon>
                <ur-icon v-else sm @click="toggleExpand">expand_menu</ur-icon>
            </div>
        </div>
        <div v-if="isExpend" class="list-item__expand" ref="expand">
            <!--
                $ver: v0.1.3
                <em>expandable</em> 기능 사용 시 펼쳐지는 부분의 컨텐츠 영역입니다.
                #The content area of ​​the expanded portion of the <em>expandable</em> feature.
            -->
            <slot name="expand" />
        </div>
    </div>
</template>

<script>
    const A = 'A';
    // ur-list-item은 목록 형태료 표현될 화면의 목록의 각 행 영역을 구성하는 컴포넌트입니다.
    // content 공간을 감싸면서 설정에 따라 title을 표시하거나 내부 content를 펼치고 접는 등의 역할을 수행할 수 있습니다.
    // #ur-list-item is a component that composes each row area of ​​the list of screens to be displayed.
    // #You can display the title depending on the setting while wrapping the content space, or expand and collapse the internal content.
export default {
    name : "urListItem",
    props: {
            // $ver: v0.2.0
            // 버튼의 모양을 선택합니다. Radio 컨트롤 혹은 Check 컨트롤을 사용할 수 있습니다
            // # Determine the control of the component.
            mode      : {type: String, default: undefined},
            // $ver: v0.2.0
            // 선택되었을 때 mode의 v-model 값으로 설정되는 목표값입니다.
            // # If component is selected by mode, v-model is set as this value.
            // $default: true
            value: {
                type: [Boolean, String],
                default: true
            },
            // $ver: v0.1.3
            // Expand 기능을 활성화 합니다. 리스트 우측의 펼침/닫힘 버튼으로 동작합니다.
            // 펼쳤을 때 보여지는 컨텐츠는 <em>expand</em> 슬롯으로 작성하면 됩니다.
            // # Activate the Expand function. It acts as an expand / close button on the right side of the list.
            // # You can write the content that is shown when expanded in the <em> expand </ em> slot.
            expandable : { type: Boolean, default: false }
        },
        data() { return {
            isExpend : false,
            default: {
                mode : 'none'
            }
        }},
        watch: {
            isExpend(val) {
                this.$nextTick(()=> {
                    var x = this.$refs.expand, y = this.$refs.listItem;
                    if(val && x) {
                        var rect = x.getBoundingClientRect();
                        y.style['margin-bottom'] = rect.height+"px";
                    } else {
                        y.style['margin-bottom'] = 'auto';
                    }
                })
            }
        },
        methods: {
            toggleExpand() {
                this.isExpend = !this.isExpend
            }
        }
}
</script>


